import { API } from '../../providers/ApiInterceptorProvider';

export const bankOfEnglandApi = {
  getCurrentRate: async () => {
    try {
      const response = await API.get('/monolith/rate');
      return { status: response.status, data: response.data };
    } catch (err: any) {
      console.error(err);
      return { status: err.status, data: null };
    }
  },
};
